import {debouncer, findAncestorByNode} from '../utility/utils';
import Dom from '../utility/dom';
import Modal from './accessibility';
import {smoother} from "../utility/gsap";
import {InitializeSmoothing} from "../utility/init-gsap";
import {setCSSProps} from "../global/set-css-custom-props";

export const initializeNav = (event) => {
  // Local Admin Bar Helper
  if(window.location.href.indexOf('localhost:3334') > -1) {
    const adminBar = document.querySelector('#wpadminbar');
    // update any a tag that includes an href containing "localhost:3334" to be "localhost:3333"
    if(adminBar) {
      const adminLinks = adminBar.querySelectorAll('a[href*="localhost:3334"]');
      if(adminLinks.length){
        adminLinks.forEach(link => {
          const href = link.getAttribute('href');
          if(href && href.indexOf('localhost:3334') > -1){
            link.setAttribute('href', href.replace('localhost:3334', 'localhost:3333'));
          }
        });
      }
    }
  }
   
  // Nav Els
  const header = document.querySelector('header');
  const adminBar = document.querySelector('#wpadminbar');
  const nav = document.querySelector('.main-navigation');
  
  if(!nav){
    return;
  }

  nav.isOpen = false;
  const topLevelMenu = nav.querySelector('#primary-menu');
  const menu_toggle = nav.querySelector('.menu-toggle');
  const mega_menus = nav.querySelectorAll('.mega_menu__secondary');
  const arrow_links = nav.querySelectorAll('.mega_menu__arrow_link > a');
  const sub_menus = nav.querySelectorAll('.sub-menu');
  const sub_menu_close_triggers = nav.querySelectorAll('.mega_menu__back_sub button, .mega_menu__back button');

  const setTopLevelItemCount = () => {
    if(topLevelMenu){
      topLevelMenu.style.setProperty('--top-level-item-count', topLevelMenu.children.length);
    }
  };

  // Search Els
  // const search_wrap = header.querySelector('.header_search');
  // search_wrap.isOpen = false;
  // const search_toggle = search_wrap.querySelector('.header_search__trigger');
  // const search_dropdown = search_wrap.querySelector('.header_search__dropdown');

  const is_desktop = () => {
    return menu_toggle.offsetParent === null ? true : false;
  }

  window.addEventListener('hashLinkClicked', (e) => {
    if(e.detail.hashButtonEl.classList.contains('mega_menu__link')){
      // Close Mobile Menu
      if(!is_desktop() && nav.isOpen && !e.detail.hashButtonEl.classList.contains('btn__arrow_right')){
        menuClose();
      }

      // Close Desktop Mega Nav
      if(is_desktop()){
        document.body.classList.add('force-close-mega-nav');
        setTimeout(() => {
          document.body.classList.remove('force-close-mega-nav');
        }, 1000);
      }
    }
  });

  menu_toggle.addEventListener('click', function(e){
    if(!nav.isOpen){
      // if(search_wrap.isOpen){
      //   menuClose(search_wrap, search_toggle);
      // }
      menuOpen();
    }
    else {
      menuClose();
    }
  });

  // Ensure users can scroll mega menus on desktop by 
  // killing scrollsmoother while hovering on the header. 
  let scrollPos = smoother ? smoother.scrollTop() : window.scrollY;
  header.addEventListener('mouseenter', () => {
    if(is_desktop() && smoother){
      header.classList.add('hovered');
      smoother.kill();
      document.body.classList.remove('smoothscroll');
    }
  });
  header.addEventListener('mouseleave', () => {
    if(is_desktop() && smoother){
      header.classList.remove('hovered');
      document.body.classList.add('smoothscroll');
      InitializeSmoothing();
      scrollPos = smoother ? smoother.scrollTop() : window.scrollY;
      
      // Prevent jumping up the page on reinit
      smoother.scrollTop(scrollPos); 
    }
  });

  if(mega_menus){
    const setMegaMenuDefaultHeight = (menu) => {
      if(is_desktop()){
        const level_1_menu = menu.querySelector('ul.level_1');
        const intro = menu.querySelector('.mega_menu__intro');
        const cardWrappers = menu.querySelectorAll('.mega_menu__cards');

        const headerHeight = header.getBoundingClientRect().height;
        const adminBarHeight = !!adminBar ? adminBar.getBoundingClientRect().height : 0;
  
        const ulHeight = !!level_1_menu ? level_1_menu.getBoundingClientRect().height : 0;
        const introHeight = !!intro ? intro.getBoundingClientRect().height : 0;
        let height = ulHeight > introHeight ? Math.round(ulHeight) : Math.round(introHeight);

        // Loop through the card wrappers and ensure height accounts for any that may be taller than the menu itself
        if(cardWrappers.length){
          cardWrappers.forEach(wrapper => {
            const wrapperHeight = Math.round(wrapper.getBoundingClientRect().height) + 100;
            height = wrapperHeight > height ? wrapperHeight : height;
          });
        }
        
        menu.setAttribute('data-default-height', height);
        menu.style.setProperty('--desktop-dynamic-height', height + 'px');

        if(height < (window.innerHeight - headerHeight - adminBarHeight)){
          if(!menu.classList.contains('no_overscroll')){
            menu.classList.add('no_overscroll');
          }
        }
        else if(menu.classList.contains('no_overscroll')){
          menu.classList.remove('no_overscroll');
        }
      }
    }
    
    mega_menus.forEach(m => {
      // Set a default height for desktop mega menus, used for dynamic height transitions
      setMegaMenuDefaultHeight(m);
      let windowResizeTimer = null;
      window.addEventListener('resize', () => {
        clearTimeout(windowResizeTimer);
        windowResizeTimer = setTimeout(() => {
          setMegaMenuDefaultHeight(m);
        }, 30);
      });

      // Scroll mega-menus back to top on mouseleave
      m.addEventListener('mouseleave', () => {
        if(is_desktop()){
          m.scrollTop = 0;
        }
      });
    });
  }

  // On sub-menu arrow link hover/focus, 
  // adjust the height of the mega-menu wrapper
  if(arrow_links){
    const setHeightOnMegaMenu = (menu) => {
      // Set the starting height as the original menu height
      let height = menu.getAttribute('data-default-height');

      // Loop through all visible menus, 
      // and set the tallest height value on the megamenu
      const activeMenus = menu.querySelectorAll('.desktop_visible');
      activeMenus.forEach(am => {
        const amHeight = Math.round(am.getBoundingClientRect().height);
        height = amHeight > height ? amHeight : height;
      });

      // Ensure height accounts for visible cards that may be taller than the menu itself
      // const cards = menu.querySelectorAll('.mega_menu__card');
      // if(cards.length){
      //   cards.forEach(card => {
      //     if(card.offsetParent !== null){
      //       const cardHeight = Math.round(card.getBoundingClientRect().height) + 100;
      //       height = cardHeight > height ? cardHeight : height;
      //     }
      //   });
      // }

      menu.style.setProperty('--desktop-dynamic-height', height + 'px');
    }

    const onArrowLinkStateChange = (parentLi, parentMenu, active = true) => {
      if(is_desktop() && !parentLi.classList.contains('level_0')){
        // Set this sub-menu as being active
        const subMenu = parentLi.querySelector('ul');
        if(active){
          subMenu.classList.add('desktop_visible');
        }
        else {
          subMenu.classList.remove('desktop_visible');
        }

        setHeightOnMegaMenu(parentMenu);
      }
    }

    let mousemoveDebouncer = null;
    header.addEventListener('mousemove', (e) => {
      clearTimeout(mousemoveDebouncer);
      mousemoveDebouncer = setTimeout(() => {
        if(is_desktop()){
          arrow_links.forEach(link => {
            const parentLi = link.closest('li');
            if(!parentLi.classList.contains('level_0')){
              const parentMenu = link.closest('.mega_menu__secondary');
              const liIsHovered = (e.target == parentLi || findAncestorByNode(e.target, parentLi));
              if(!parentLi.classList.contains('hovered') && liIsHovered){
                // parentLi.classList.add('hovered')
                setMenuItemActiveOnDesktop(parentMenu, parentLi);
                onArrowLinkStateChange(parentLi, parentMenu, true);
              }
              else if(!liIsHovered && parentLi.classList.contains('active')){
                setMenuItemActiveOnDesktop(parentMenu);
                setTimeout(() => {
                  // parentLi.classList.remove('hovered');
                }, 200);
                onArrowLinkStateChange(parentLi, parentMenu, false);
              }
            };
          });
        }
      }, 10);
    });

    arrow_links.forEach(link => {
      const parentLi = link.closest('li');
      const parentMenu = link.closest('.mega_menu__secondary');

      parentLi.addEventListener('focusin', () => {
        if(is_desktop()){
          setMenuItemActiveOnDesktop(parentMenu, parentLi);
        }
        onArrowLinkStateChange(parentLi, parentMenu, true);
      });

      parentLi.addEventListener('focusout', () => {
        if(is_desktop()){
          setMenuItemActiveOnDesktop(parentMenu);
        }
        onArrowLinkStateChange(parentLi, parentMenu, false);
      });
    });
  }
  

  // search_toggle.addEventListener('click', function(e){
  //   if(!search_wrap.isOpen){
  //     if(nav.isOpen){
  //       menuClose();
  //     }
  //     menuOpen(search_wrap, search_toggle);
  //   }
  //   else {
  //     menuClose(search_wrap, search_toggle);
  //   }
  // });

  const menuClose = (menu = nav, toggle = menu_toggle) => {
    menu.isOpen = false;
    // Set closing class for css animation help
    menu.classList.add('closing');
    document.body.classList.remove('menu-open');
    const navItems = menu.querySelectorAll('li');
    if(navItems.length){
      navItems.forEach(item => {
        item.classList.add('closing');
      });
    }
    setTimeout(()=>{
      menu.classList.remove('closing');
      if(navItems.length){
        navItems.forEach(item=>{
          item.classList.remove('closing');
        })
      }
    }, 700);
    
    // Set Active Class
    menu.classList.remove('toggled');
    toggle.classList.remove('active');
    toggle.blur();
    Dom.body.classList.remove('scroll-lock');
    if(smoother){
      smoother.paused(false);
    }

    // Set Aria Hidden Attribute
    toggle.setAttribute('aria-expanded', 'false');

    // Handle focus trapping
    Modal.close(menu);
    toggle.setAttribute('tabindex', '1');

    // if(menu == search_wrap){
    //   const donateBtn = search_wrap.querySelector('.donate');
    //   if(!!donateBtn){
    //     donateBtn.setAttribute('tabindex', '1');
    //   }
    // }

    if(sub_menus.length && menu == nav){
      sub_menus.forEach(sm => {
        if(sm.isOpen){
          sub_menu_close(sm);
        }
      });
    }

    // Reset CSS props
    setCSSProps();
  }

  const menuOpen = (menu = nav, toggle = menu_toggle) => {
    menu.isOpen = true;

    // Set Active Class
    menu.classList.add('toggled');
    document.body.classList.add('menu-open');
    toggle.classList.add('active');
    toggle.blur();
    Dom.body.classList.add('scroll-lock');
    if(smoother){
      smoother.paused(true);
    }

    // Set Aria Hidden Attribute
    toggle.setAttribute('aria-expanded', 'true');

    // Handle focus trapping
    Modal.open(menu);

    // If search menu, set focus on search input
    // if(menu == search_wrap){
    //   const input = search_wrap.querySelector('input[type="search"]');
    //   if(input){
    //     input.focus();
    //   }
    // }

    // Reset CSS props
    setCSSProps();
  }

  if(arrow_links.length){ 
    arrow_links.forEach(link => {
      link.addEventListener('click', (e) => {
        if(!is_desktop()){
          const parentLi = link.closest('li');
          const target = parentLi.querySelector('.sub-menu');

          if(!target || target.classList.contains('empty-on-desktop')){
            return;
          }

          e.preventDefault();
          link.blur();
          sub_menu_open(target);
        }
      });
    });
  }

  // Back Button Trigger Clicks
  if(sub_menu_close_triggers.length){
    sub_menu_close_triggers.forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        const triggerDepth = trigger.getAttribute('data-depth');
        const ancesterLI = trigger.closest('li.level_0');
        const activeSubs = ancesterLI.querySelectorAll('.sub-menu.active');
        activeSubs.forEach((sub) => {
          const subDepth = sub.getAttribute('data-depth');
          if(subDepth >= triggerDepth){
            sub_menu_close(sub);
          }
        });
      });
    });
  }

  const sub_menu_open = (menu) => {
    // First, position the menu below the header, in case the 
    // previous sub-menu el was scrolled down (fixed inside fixed issue)
    const top = menu.getBoundingClientRect().top;
    const headerOffset = header.getBoundingClientRect();
    const headerHeight = headerOffset.height + headerOffset.top;
    const dif = headerHeight - top;
    menu.style.setProperty('--sub-scrolled', Math.round(dif) + 'px');

    menu.isOpen = true;
    menu.setAttribute('aria-hidden', 'false');
    menu.classList.add('active');
  }

  const sub_menu_close = (menu) => {
    menu.isOpen = false;
    menu.setAttribute('aria-hidden', 'true');
    menu.classList.remove('active');

    // reset the top position
    setTimeout(() => {
      menu.style.setProperty('--sub-scrolled', '0px');
    }, 200);
  }

  const setMenuItemActiveOnDesktop = (menu, item = null) => {
    const el = item ? item : menu.querySelector('.mega_menu__arrow_link');

    // Unset any other active items within this menu
    const activeItems = menu.querySelectorAll('.active');
    if(activeItems.length){
      activeItems.forEach(ai => {
        if(ai !== el){
          ai.classList.remove('active');
        }
      });
    }
    
    if(el && !el.classList.contains('active')){
      el.classList.add('active');
    }
  }

  // Set menu state on load and resize if changing from mobile to desktop.
  function set_menu_state(){
    // Desktop
    if(is_desktop()){
      if(!nav.classList.contains('is_desktop')){
        nav.classList.add('is_desktop');
        nav.classList.remove('is_mobile');
      }

      // if mobile state classes are present, remove them.
      if(nav.classList.contains('toggled')){
        menuClose();
        Modal.setToFocusable(nav);
      }

      // set aria-hidden if not already set to false
      if(menu_toggle.getAttribute('aria-expanded') !== 'true'){
        menu_toggle.setAttribute('aria-expanded', 'true');
      }

      // set aria-hidden on sub-menus
      if(sub_menus.length){
        sub_menus.forEach(menu => {
          if(menu.isOpen){
            menu.isOpen = false;
          }

          if(menu.getAttribute('aria-hidden') !== 'false') {
            menu.setAttribute('aria-hidden', 'false');
          }

          // If the first item in the sub-menu has a sub-menu, set the li to .active
          setMenuItemActiveOnDesktop(menu);
        });
      }

      // Remove .is_mobile class on arrow links for mobile specific styles
      if(arrow_links.length){
        arrow_links.forEach(link => {
          if(link.classList.contains('is_mobile')){
            link.classList.remove('is_mobile');
          }
        });
      }

      // Remove .mega_menu__cta_btn from sub-menu on desktop
      const subMenus = nav.querySelectorAll('.sub-menu');
      if(subMenus.length){
        subMenus.forEach(sub => {
          if(!sub.classList.contains('cta_appended')){
            return;
          }
          sub.classList.remove('cta_appended');
          const ctaBtnLi = sub.querySelectorAll('.mega_menu__cta_li');
          if(ctaBtnLi.length){
            ctaBtnLi.forEach(btn => btn.remove());
          }
        });
      }

      // Move Cards within sub-menu back to their original position, outside of the sub-menu
      const cardWrappers = nav.querySelectorAll('.mega_menu__cards.is_mobile');
      if(cardWrappers.length){
        cardWrappers.forEach(wrapper => {
          const mobileLiWrapper = wrapper.closest('li');
          const parentList = wrapper.closest('.sub-menu');
          if(parentList){
            parentList.parentNode.insertBefore(wrapper, parentList.nextSibling);
            wrapper.classList.remove('is_mobile');

            if(mobileLiWrapper && mobileLiWrapper !== wrapper && mobileLiWrapper.children.length === 0){
              mobileLiWrapper.remove();
            }
          }
        });
      }
    }
    // Mobile
    else {
      if(!nav.classList.contains('is_mobile')){
        nav.classList.remove('is_desktop');
        nav.classList.add('is_mobile');
      }

      if(header.classList.contains('hovered')){
        header.classList.remove('hovered');
      }
      
      // set aria-hidden if not already set to true and if menu isn't currently active
      if(!nav.classList.contains('toggled') && menu_toggle.getAttribute('aria-expanded') !== 'false'){
        menu_toggle.setAttribute('aria-expanded', 'false');
      }

      // set aria-hidden on sub-menus
      if(sub_menus.length){
        if(!sub_menus.isOpen)
        sub_menus.forEach(menu => {
          if(!menu.isOpen && menu.getAttribute('aria-hidden') !== 'true') {
            menu.setAttribute('aria-hidden', 'true');
          }
        });
      }

      // Set .mobile class on arrow links for mobile specific styles
      if(arrow_links.length){
        arrow_links.forEach(link => {
          if(!link.classList.contains('is_mobile')){
            link.classList.add('is_mobile');
          }
        });
      }

      // Remove any desktop .active classes on arrow links
      if(arrow_links.length){
        arrow_links.forEach(link => {
          if(link.classList.contains('active')){
            link.classList.remove('active');
          }
        });
      }

      // Copy .mega_menu__cta_btn into sub-menu on mobile
      const ctaBtn = nav.querySelector('.mega_menu__cta_btn');
      const subMenus = nav.querySelectorAll('.sub-menu');
      if(ctaBtn && subMenus.length){
        subMenus.forEach(sub => {
          if(sub.classList.contains('cta_appended')){
            return;
          }
          sub.classList.add('cta_appended');
          const newLi = document.createElement('li');
          newLi.classList.add('mega_menu__cta_li');
          const clonedBtn = ctaBtn.cloneNode(true);
          newLi.appendChild(clonedBtn);
          sub.appendChild(newLi);
        });
      }

      // Move Cards within sub-menu, inside a new li element
      const cardWrappers = nav.querySelectorAll('.mega_menu__cards');
      if(cardWrappers.length){
        cardWrappers.forEach(wrapper => {
          const prevUl = wrapper.previousElementSibling;
          if(prevUl && prevUl.classList.contains('sub-menu')){
            const newLi = document.createElement('li');
            newLi.classList.add('mega_menu__cards_li');
            wrapper.parentNode.insertBefore(newLi, wrapper);
            newLi.appendChild(wrapper);
            wrapper.classList.add('is_mobile');
            prevUl.appendChild(newLi);
          }
        });
      }
    }
  }
  set_menu_state();
  setTopLevelItemCount();

  // Resize modals on window resize
  window.addEventListener('resize', debouncer(function(){
    set_menu_state();
    setTopLevelItemCount();
  }, 15));


  // If focus is applied to a header nav el, 
  // remove hide-header class if present
  header.addEventListener('focusin', () => {
    if(header.classList.contains('hide-header')){
      header.classList.remove('hide-header');
    }
  });
};